export const ROUTES = {
    signIn: '/',
    signUp: '/signup',
    main: '/channels/:chanName',
    generalChannel: '/channels/general',
    randomChannel: '/channels/random'
}


// WEBPACK FOOTER //
// ./src/constants.js